import { UserDTO } from 'models'

export const getUserFullName = (user: UserDTO): string => {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim()
}
